import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utils from './../../../../utils';
import PersonaFitRoles from './constants/PersonaFitRoles';
import Rozet from './components/Rozet/Rozet';
import style from './style/personafitrozet.scss'; // eslint-disable-line

const labelOffset = 6.25; /* value used to offset label positions by character count */
const rozetSliceMultiplier = 2; /* this enlarges the Rozet slices so they reach the edges */

/* this is the persona.fit implementation of the Rozet component used for the AssessmentReport in Participant Portal */

export default class PersonaFitRozet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            scores: [],
            sortByScore: false
        };

        this.toggleScoreSorting = this.toggleScoreSorting.bind(this);
        this.populateScores = this.populateScores.bind(this);
    }

    toggleScoreSorting() {
        if (!this.state.sortByScore) {
            this.setState({
                scores: Utils.numericallySortFieldInArray(this.state.scores, 'value'),
                sortByScore: true
            });
        } else {
            this.populateScores(); // revert back to how it was initially received
        }
    }

    getIdentifierForScoreKey(key) {
        let translatedValue = null;

        Object.keys(PersonaFitRoles).forEach(role => {
            Object.keys(PersonaFitRoles[role]).forEach(identifier => {
                if (PersonaFitRoles[role][identifier] === key) {
                    translatedValue = identifier;
                }
            });
        });

        return translatedValue;
    }

    populateScores() {
        this.setState({ scores: [...this.props.scores], sortByScore: false });
    }

    componentDidMount() {
        this.populateScores();
    }

    render() {
        const { classes, children, i18nParticipation, sortByClickEnabled } = this.props;
        const rozetSlices = [];
        const rozetLabels = [];
        const rozetRings = [];

        // specific for implementation of Rozet for Persona.fit: coordinates for label placement
        const rozetLabelCoordinates = [
            'M250,250 L146,0 L353,0 Z',
            'M250,250 L353,0 L500,146 Z',
            'M250,250 L500,146 L500,353 Z',
            'M250,250 L500,353 L353,500 Z',
            'M250,250 L353,500 L146,500 Z',
            'M250,250 L146,500 L0,353 Z',
            'M250,250 L0,353 L0,146 Z',
            'M250,250 L0,146 L146,0 Z'
        ];
        const rozetRingCenterPoints = [425, 598, 770, 455, 270, 88, 80, 255];

        // take either the scores from the state (old) or directly from props (new, for pdf)
        // todo: test and see why its not taking props in the first place
        const scores = this.state.scores.length ? this.state.scores : this.props.scores;

        scores.forEach((score, index) => {

            // labels
            const labelIdentifier = `ring-clip-${score.key}`;

            rozetLabels.push(<clipPath id={ labelIdentifier } key={ `label-${index}` }>
                <path d={ rozetLabelCoordinates[index] }/>
            </clipPath>);

            // rings
            const ringIdentifier = `'#ring-clip-${score.key}'`;
            const label = i18nParticipation[`report_rozet_${score.label.toLowerCase()}`] || score.label.toLowerCase();

            rozetRings.push(<g key={ `ring-${index}` }>
                <circle
                    style={{ clipPath: `url(${ringIdentifier})` }}
                    className={ style[this.getIdentifierForScoreKey(score.key).toLowerCase()] }
                    cx="250"
                    cy="250"
                    r="250"
                />
                <text className={ style.personafitRozetLabel } dx={ (rozetRingCenterPoints[index] - (label.length * labelOffset)) }>
                    <textPath xlinkHref={ (index < 3 || index > 5) ? '#text-concave' : '#text-convex' }>{ /* text orientation depends on label position */ }
                        { label }
                    </textPath>
                </text>
            </g>);

            // slices
            const clipPath = `#ring-clip-${score.key}`;

            rozetSlices.push(<circle
                key={ `circle-${index}` }
                style={{ clipPath: `url('${clipPath}')` }}
                className={ style[this.getIdentifierForScoreKey(score.key).toLowerCase()] }
                cx="250"
                cy="250"
                r={ score.value >= 0 ? score.value * rozetSliceMultiplier : 0 }
            />);
        });

        return (
            <section
                className={ `${style.personafitRozet} ${classes}` }
                onClick={
                    sortByClickEnabled ? () => {
                        this.toggleScoreSorting();
                    }
                        : null
                }
            >
                <Rozet>
                    <defs id="path-definitions">
                        { rozetLabels }
                        <path id="text-concave" d="M48,333 A219,219 0 1,1 452,333" />
                        <path id="text-convex" d="M36,338 A231,231 0 0,0 464,338" />
                    </defs>
                    <g id="ring">{ rozetRings }</g>
                    <g><circle fill="#fff" cx="250" cy="250" r="205" /></g>{ /* the white background circle on which the slices are projected */ }
                    <g id="score">{ rozetSlices }</g>
                </Rozet>
                { children }
            </section>
        );
    }
}

PersonaFitRozet.propTypes = {
    classes: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    scores: PropTypes.array,
    i18nParticipation: PropTypes.object,
    sortByClickEnabled: PropTypes.bool
};

PersonaFitRozet.defaultProps = {
    classes: '',
    children: {},
    scores: [],
    i18nParticipation: {},
    sortByClickEnabled: false
};
